export default __webpack_public_path__ + "static/media/img_504.751c146f.jpg";